import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);

import user from './user';
import organization from './organization';
import catalog from './catalog';
import dashboard from './dashboard';
import histories from './historiesPetsAndProject';
import expenditureRequest from './expenditureRequest';
import profileNavigation from './profileNavigation';
import publication from './publication';
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
    modules: {
        user, organization, catalog, profileNavigation,
        dashboard, histories, publication, expenditureRequest
    },
    plugins: [createPersistedState({
        paths: ['user', 'organization', 'catalog', 'profileNavigation', 'dashboard', 'histories']
    })],
    state: {
        translates: null,
    },
    mutations: {
        setTranslates(state, data) {
            state.translates = data
        },
    },
    getters: {
        translates: state => state.translates,
        t: state => key => state.translates?.[key] ?? '',
        translate: state => key =>  {
            return Object.keys(state.translates).includes(key) ? state.translates[key] : '';
        }
    },
    actions: {
        async fetchTranslations({commit}) {
            const {data: {data}} = await axios.get(window.location.origin + '/api/front-translations');

            commit('setTranslates', data.translations)
        },
    }
})
